export class JobTypeMatch {
    jobTypeId: number;
    jobTypeName: string;
    isMatched: boolean;
}
